import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async Current_company_station_inventory_stock(data) {
    let response = await apiCall(
      "invetory/current_stations_stock_graphical",
      data
    );
    return response;
  },
  async Current_station_inventory_stock(data) {
    let response = await apiCall("invetory/current_single_station_stock", data);
    return response;
  },
  async single_station_stock_monthly_flow(data) {
    let response = await apiCall(
      "invetory/single_station_stock_monthly_flow",
      data
    );
    return response;
  },
};
